import React, { Component } from "react";
import Translator from "../../requests/apa/Translator";
import ModalWrapper, { withOnClose } from "./ModalWrapper";
import './styles/AAFModalLandingSTB.css';
import Assets from '../../requests/apa/Asset';
import DeviceStorage from "../DeviceStorage/DeviceStorage";
import { Button, cls } from "../../packages/components";
import ButtonBack from "../LandingPage/components/ButtonBack";

class AAFModalLandingSTB extends Component{
    constructor(props) {
        super(props);
        this.state = { 
            imageError: false,
            buttonOnError: false,
            buttonOffError: false,
            focus: false
        }
        this.region = DeviceStorage.getItem("region");
        this.buttonOffDefault = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_focus_Off`, '');
        this.buttonOff = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_focus_Off_${this.region}`, '') || this.buttonOffDefault;
        this.buttonOnDefault = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_focus_On`, '');
        this.buttonOn = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_focus_On_${this.region}`, '') || this.buttonOnDefault;
    }

    componentDidMount() {
        window.SpatialNavigation.focus('.btn-entendido')
    }

    render() {
       
        const { buttonOnError, buttonOffError, focus } = this.state;
        const { buttonOn, buttonOff, buttonOnDefault, buttonOffDefault } = this;

        let image, defaultImage;
        if(this.props.isError) {
            defaultImage = Assets.get(`LandingPageClaroTv06_Metadata02_Imagen`)
            image = Assets.get(`LandingPageClaroTv06_Metadata02_Imagen_${this.region}`, '') || defaultImage;    
        } else {
            defaultImage = Assets.get(`LandingPageClaroTv05_Metadata02_Imagen`)
            image = Assets.get(`LandingPageClaroTv05_Metadata02_Imagen_${this.region}`, '') || defaultImage;
        }
        
        const p = {
            showLogo: false,
            alwaysEnabled: true,
            buttonsAlign: 'vertical',
            aafNewStyle: true,
            className: 'aaf-modal landing_page-modal',

            buttons: [
                {
                    content: <div>
                                <img src={buttonOnError ? buttonOnDefault : buttonOn} 
                                    onError={buttonOnError ? () => {} : () => {
                                        this.setState({buttonOnError: true})
                                    }}
                                    style={{display: !focus ? "none" : "block"}}
                                />
                                <img src={buttonOffError ? buttonOffDefault : buttonOff} 
                                    onError={buttonOffError ? () => {} : () => {
                                        this.setState({buttonOffError: true})
                                    }}
                                    style={{display: focus ? "none" : "block"}}
                                />
                            </div>,
                    props: {
                        onClick: (e) => {
                            if(this.props.isError) {
                                this.props.handleClose();
                            } else {
                                this.props.handleClose(e, this.props.callback);
                            }
                        },
                        onFocus: () => this.setState({focus: true}),
                        onBlur: () => this.setState({focus: false}),
                        className: 'btn focusable btn-entendido',
                    },
                },
            ],
            colorButtons: []
        };
        return (
            <ModalWrapper {...p}>
                <ButtonBack onClick={(e) => this.props.handleClose(e)}/>
                <img src={this.state.imageError ? defaultImage : image} style={{position: "absolute", top: 0, left: 0}}
                    onError={this.state.imageError ? null : () => {
                        this.setState({imageError: true})
                    }}
                />
            </ModalWrapper>
        );
    }
};

export default withOnClose(AAFModalLandingSTB);


// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalLandingSTB.jsx